import React, { useRef, useState } from 'react';
import { Button, Overlay, Popover } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { logoutRoute, myAccountRoute } from 'App/common/routeLookup';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import { useUserContext } from 'App/contexts/UserContext';

function getTruncatedEmail(email) {
    return email?.replace(/\+.?[^@]*/i, '');
}

const UserIcon = () => {
    const navigate = useNavigate();
    const user = useUserContext();
    const [show, setShow] = useState(false);
    const targetRef = useRef(null);

    const goLogout = () => navigate(logoutRoute);

    const goMyAccount = () => {
        setShow(false);
        return navigate(myAccountRoute);
    };

    const UserPopover = (
        <Popover id="user-profile-popover">
            <Popover.Content>
                <div className="add-header-popover-heading">
                    <div
                        id="user-full-name"
                        className="add-header-popover-username"
                    >{`${user.first_name} ${user.last_name}`}</div>
                    <div id="user-email" className="add-header-popover-subtext">
                        {user?.CdcType === 'user:Support:provision' ? getTruncatedEmail(user.email) : user.email}
                    </div>
                    {user?.CdcType === 'user:Support:provision' ? (
                        <div id="user-company" className="add-header-popover-subtext">
                            ({user.active_company.Name})
                        </div>
                    ) : null}
                </div>
                <FormButtonGroup style={{ justifyContent: 'space-between' }}>
                    <Button
                        id="user-profile-popover-button-logout"
                        variant="outline-secondary"
                        size="sm"
                        onClick={goLogout}
                    >
                        Sign Out
                    </Button>
                    <Button
                        id="user-profile-popover-button-my-account"
                        variant="primary"
                        size="sm"
                        onClick={goMyAccount}
                    >
                        My Account
                    </Button>
                </FormButtonGroup>
            </Popover.Content>
        </Popover>
    );

    return (
        <>
            <Button
                variant="link"
                id="user-icon"
                className="icon"
                onClick={() => setShow(!show)}
                ref={targetRef}
                aria-label="User popover"
            >
                <i className="fas fa-fw fa-user-circle" />
            </Button>

            <Overlay
                show={show}
                onHide={() => setShow(false)}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react-hooks/refs
                target={targetRef.current}
                placement="bottom"
                rootClose
            >
                {UserPopover}
            </Overlay>
        </>
    );
};

export default UserIcon;
